import { all } from 'redux-saga/effects'

import operationLog from './operationLog/saga'

export default function* operationLogSaga() {
  yield all([operationLog()])
}
